import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { translate } from 'react-i18next';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import Markdown from 'react-markdown';
import withUser from '../helpers/withUser';
import withRedirect from '../helpers/withRedirect';
import withInvite from '../helpers/withInvite';
import logout from '../helpers/logout';
import Fullscreen from '../components/blocks/Fullscreen';
import Page from '../components/blocks/Page';
import ContainerSmall from '../components/blocks/ContainerSmall';
import H1 from '../components/headings/H1';
import LoginForm from '../components/forms/LoginForm';
import LogoLarge from '../components/icons/LogoLarge';
import Block from '../components/blocks/Block';
import FormBlock from '../components/blocks/FormBlock';
import Text from '../components/text/Text';
import ActionLink from '../components/links/ActionLink';
import Loader from '../components/icons/Loader';
import FadeIn from '../components/blocks/FadeIn';

const Login = ({ t, loading, spaceName }) => (
  <Fullscreen fill>
    <Page>
      <ContainerSmall>
        {loading ? (
          <Loader
            size={64}
            strokeWidth={4}
            color="#f39b1a"
            style={{
              margin: '49px auto',
            }}
          />
        ) : (
          <FadeIn>
            <LogoLarge />
            {spaceName ? (
              <H1><Markdown
                source={t('login_and_join_space', {
                  defaultValue: 'Login and join **{{spaceName}}**',
                  spaceName,
                })}
              /></H1>
            ) : (
              <H1><Markdown
                source={t('login_title', {
                  defaultValue: 'Login to SpaceTranslate',
                })}
              /></H1>
            )}
            <FormBlock>
              <LoginForm
                showLabels
                {...spaceName && { onCancel: logout }}
              />
            </FormBlock>
            <Block>
              <Text>
                {spaceName ? (
                  <Markdown
                    source={t('need_signup', {
                      defaultValue: 'Don\'t have a SpaceTranslate account? [Sign up]({{url}})',
                      url: '/signup',
                    })}
                    renderers={{
                      link: attr => <ActionLink to={attr.href} {...attr} />,
                    }}
                  />
                ) : (
                  <Markdown
                    source={t('signup_lead', {
                      defaultValue: 'Need a SpaceTranslate space? [Create a space]({{url}}).',
                      url: '/signup',
                    })}
                    renderers={{
                      link: attr => <ActionLink to={attr.href} {...attr} />,
                    }}
                  />
                )}
              </Text>
            </Block>
          </FadeIn>
        )}
      </ContainerSmall>
    </Page>
  </Fullscreen>
);
Login.propTypes = {
  t: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  spaceName: PropTypes.string,
};
Login.defaultProps = {
  spaceName: null,
  loading: true,
};

export default compose(
  translate(),
  withUser,
  withInvite,
  withRedirect(({ user }) => user && '/spaces'),
  graphql(gql`
    query InvitePage($spaceId: ID) {
      space(id: $spaceId) {
        _id
        name
      }
    }
  `, {
    options: ({ spaceId }) => ({
      variables: { spaceId },
    }),
    props: ({ data: { loading, space } = {} }) => ({
      loading,
      ...space && {
        spaceName: space.name,
      },
    }),
  }),
)(Login);



// WEBPACK FOOTER //
// ./src/pages/login.js